import { auth } from './auth';
import { activation } from './activation';
import { packages } from './packages';
import { apiStatus } from './apiStatus';
import { documentUpload } from './documentUpload';
import { sales } from './sales';
import { location } from './location';
import { payment } from './payment';
import { pre2pos } from './pre2pos';
import { prospects } from './prospects';
export default { auth, activation, packages, apiStatus, documentUpload, sales, location, payment, pre2pos, prospects };
